import CodeFigure from "@app/components/CodeFigure";
import YoutubeVideo from "@app/components/YoutubeVideo";
import * as React from 'react';
export default {
  CodeFigure,
  YoutubeVideo,
  React
};